<i18n>
{
  "en": {
    "dictionaryItems": {
      "id": "ID",
      "code": "Code",
      "name": "Name"
    }
  },
  "ru": {
    "dictionaryItems": {
      "id": "ID",
      "code": "Код",
      "name": "Наименование"
    }
  }
}
</i18n>

<template>
  <div>
    <dx-tree-list
      v-if="items"
      class="data-grid"
      id="items-tree-list"
      :data-source="items"
      :show-borders="true"
      key-expr="id"
      parent-id-expr="parent.id"
      :show-row-lines="true"
      @context-menu-preparing="addMenuItems"
      @editor-preparing="onEditorPreparing"
      @initialized=initializedGrid
      ref="dataGrid"
    >
      <dx-filter-row :visible="true" />
      <dx-header-filter :visible="true"/>
      <dx-scrolling mode="standard" />
      <dx-paging :enabled="true" :page-size="rowCountDictionaryItem" :page-index="pageIndex" />

      <dx-sorting mode="multiple" />
      <dx-state-storing
        :enabled="true"
        type="custom"
        :customLoad="stateLoad"
        :customSave="stateSave"
      />

      <dx-column
        :width="120"
        data-field="code"
        :caption="$t('dictionaryItems.code')"
        :allow-header-filtering="false"
        :allow-filtering="true"
        :editor-options="{maxLength: 50}"
      />

      <dx-column
        data-field="name"
        :caption="$t('dictionaryItems.name')"
        :allow-header-filtering="false"
        :allow-filtering="true"
        :editor-options="{maxLength: 250}"
      />
    </dx-tree-list>

    <CustomColumnChooser
      :visible="visible"
      :columns="columns"
      :onApply="onApply"
      :onHiding="onHiding"
    />
  </div>
</template>

<script>
import baseView from '../base.vue';

import {
  DxTreeList, DxColumn, DxFilterRow, DxHeaderFilter, DxPaging, DxScrolling,
  DxStateStoring, DxSorting
} from 'devextreme-vue/tree-list';

import CustomColumnChooser from "@/components/column-chooser/CustomColumnChooser.vue";

import { findDictionaryItems } from '@/services/api';

import { DataDrid } from "@/mixins/dataDridMixin";

export default {
  name: 'dictionary-items',
  props: ['dictionary'],
  extends: baseView,
  mixins: [DataDrid],
  components: {
    DxTreeList, DxColumn, DxFilterRow, DxHeaderFilter, DxPaging, DxScrolling,
    DxStateStoring, CustomColumnChooser, DxSorting
  },
  data() {
    return {
      items: null,
      pageIndex: 0,
      parentDictionary: []
    };
  },
  computed: {
    rowCountDictionaryItem() {
      return this.countRows(this.gridBodyHeight);
    },
  },
  methods: {
    onEditorPreparing(e) {
      this.applyFilterRowTimeout(e);
    },
    async loadData(dictionary) {
      try {
        const data = await findDictionaryItems({
            page: '999,1',
            filterJson: ['dictionary.id', '=', dictionary.id]
          });
        this.items = data.pageRows;
      } catch(err) {
        // eslint-disable-next-line
        console.error(err);
      }
    }
  },
  created() {
    this.gridStateKey = 'gridDictionaryItems' + this.dictionary.code;

    this.loadData(this.dictionary);
  },
  beforeDestroy() {
    const state = this.dataGrid.state();
    this.stateSave(state);
  },
  watch: {
    dictionary(dictionary) {
      this.loadData(dictionary);
    }
  },
};
</script>

<style lang="scss">
</style>
